export default class BookingTimeSlot {
  public time: string
  public max: number
  public used: number

  public constructor (time: string, max: number, used: number) {
    this.time = time
    this.max = max
    this.used = used
  }
}
